var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ol',{staticClass:"rules"},[_vm._l((_vm.rules),function(rule,index){return _c('rule-display-preview',{key:index,attrs:{"rule":rule,"index":index,"col-headers":_vm.columnData.colHeadersPerRule[index]}})}),_vm._v(" "),_vm._l((_vm.mapping),function(map,index){return _c('identifier-display-preview',_vm._b({key:map.type,attrs:{"index":index,"col-headers":_vm.colHeaders}},'identifier-display-preview',map,false))})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"js":"babel-loader"}}!./node_modules/vue-loader/lib?{"loaders":{"js":"babel-loader"}}!./galaxy/scripts/components/RulesDisplay.vue?vue&type=template&id=5b1c8cf4
// module id = 680
// module chunks = 5